module.exports = __webpack_public_path__ + "media/images/pc/components/store/no_image-e3d74c8ef38dbd2329bea4034feaf756.jpg";